export default __webpack_public_path__ + "static/media/green_firework.8257fdad.jpg";